export function addZero(mins: string | number = 0) {
    const shouldAdd = typeof mins === "string" ? mins.length < 2 : mins < 10;
    return `${shouldAdd ? "0" : ""}${Number(mins)}`;
}

export const getLocalDateTimeAsString = (d: Date) => {
    return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())} ${addZero(d.getHours())}:${addZero(d.getMinutes())}:${addZero(d.getSeconds())}`;
};
